import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaUser,
  FaBuilding,
  FaSnowflake,
  FaWhatsapp,
  FaCalendar,
} from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log("Form submitted:", formData);
  };

  const contactInfo = [
    {
      icon: <FaPhone className="text-primary" />,
      title: "Phone",
      details: ["+92 305 4743725"],
      action: "Call Now",
      href: "tel:+923054743725",
    },
    {
      icon: <FaWhatsapp className="text-success" />,
      title: "WhatsApp",
      details: ["+92 305 4743725"],
      action: "Chat on WhatsApp",
      href: "https://wa.me/923054743725",
    },
    {
      icon: <FaEnvelope className="text-primary" />,
      title: "Email",
      details: ["miansaif351@gmail.com"],
      action: "Send Email",
      href: "mailto:miansaif351@gmail.com",
    },
    {
      icon: <FaMapMarkerAlt className="text-primary" />,
      title: "Address",
      details: ["Lahore, Punjab, Pakistan"],
      action: "Get Directions",
      href: "#",
    },
    {
      icon: <FaClock className="text-primary" />,
      title: "Hours",
      details: ["Mon-Fri: 8AM-6PM", "Sat: 9AM-4PM", "Emergency: 24/7"],
      action: "Schedule Service",
      href: "#",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Contact AC Service Lahore | Book AC Repair & Installation</title>
        <meta
          name="description"
          content="Contact us for AC service in Lahore & Punjab. Book AC repair, installation, or maintenance. 24/7 support. رابطہ کریں ای سی سروس لاہور۔"
        />
        <meta
          name="keywords"
          content="Contact AC Service Lahore, Book AC Repair Lahore, AC Installation Contact, رابطہ ای سی سروس لاہور"
        />
        <meta
          property="og:title"
          content="Contact AC Service Lahore | Book AC Repair & Installation"
        />
        <meta
          property="og:description"
          content="Contact us for AC service in Lahore & Punjab. Book AC repair, installation, or maintenance. 24/7 support."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://procoolac.com/contact" />
        <meta
          property="og:image"
          content="https://procoolac.com/og-image.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact AC Service Lahore | Book AC Repair & Installation"
        />
        <meta
          name="twitter:description"
          content="Contact us for AC service in Lahore & Punjab. Book AC repair, installation, or maintenance. 24/7 support."
        />
        <meta
          name="twitter:image"
          content="https://procoolac.com/og-image.jpg"
        />
      </Helmet>
      <section className="section-padding bg-light">
        <Container>
          <Row className="text-center mb-5">
            <Col lg={8} className="mx-auto">
              <h2 className="display-5 fw-bold mb-3 text-gradient">
                Get In Touch
              </h2>
              <p className="lead text-muted">
                Ready to experience professional HVAC services? Contact us today
                for a free consultation, quote, or emergency service. Our team
                is ready to help you with all your air conditioning needs.
              </p>
            </Col>
          </Row>

          <Row className="g-5">
            {/* Contact Form */}
            <Col lg={7}>
              <Card className="border-0 shadow-sm">
                <Card.Body className="p-5">
                  <div className="text-center mb-4">
                    <FaSnowflake
                      className="text-primary mb-3"
                      style={{ fontSize: "3rem" }}
                    />
                    <h3 className="fw-bold">Request a Quote</h3>
                    <p className="text-muted">
                      Fill out the form below and we'll get back to you within
                      24 hours.
                    </p>
                  </div>

                  <Form onSubmit={handleSubmit}>
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            <FaUser className="me-2" />
                            Full Name *
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="Enter your full name"
                            className="border-2"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            <FaEnvelope className="me-2" />
                            Email Address *
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="Enter your email"
                            className="border-2"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            <FaPhone className="me-2" />
                            Phone Number
                          </Form.Label>
                          <Form.Control
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="Enter your phone number"
                            className="border-2"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            <FaBuilding className="me-2" />
                            Service Type
                          </Form.Label>
                          <Form.Select
                            name="service"
                            value={formData.service}
                            onChange={handleChange}
                            className="border-2"
                          >
                            <option value="">Select a service</option>
                            <option value="installation">
                              AC Installation
                            </option>
                            <option value="repair">AC Repair</option>
                            <option value="maintenance">Maintenance</option>
                            <option value="commercial">Commercial HVAC</option>
                            <option value="residential">Residential AC</option>
                            <option value="emergency">Emergency Service</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col xs={12}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            Message
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Tell us about your HVAC needs..."
                            className="border-2"
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12}>
                        <Button
                          type="submit"
                          variant="primary"
                          size="lg"
                          className="w-100 fw-semibold mb-3"
                          style={{ borderRadius: "30px" }}
                        >
                          Send Message
                        </Button>
                        <Button
                          as={Link}
                          to="/booking"
                          variant="info"
                          size="lg"
                          className="w-100 fw-semibold"
                          style={{ borderRadius: "30px" }}
                        >
                          <FaCalendar className="me-2" />
                          Book Appointment
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>

            {/* Contact Information */}
            <Col lg={5}>
              <div className="space-y-4">
                {contactInfo.map((info, index) => (
                  <Card key={index} className="border-0 shadow-sm">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-start">
                        <div className="me-3 mt-1">{info.icon}</div>
                        <div className="flex-grow-1">
                          <h6 className="fw-bold mb-2">{info.title}</h6>
                          {info.details.map((detail, detailIndex) => (
                            <p key={detailIndex} className="text-muted mb-1">
                              {detail}
                            </p>
                          ))}
                          <a
                            href={info.href}
                            className="btn btn-outline-primary btn-sm mt-2"
                            target={
                              info.href.startsWith("http") ? "_blank" : "_self"
                            }
                            rel={
                              info.href.startsWith("http")
                                ? "noopener noreferrer"
                                : ""
                            }
                          >
                            {info.action}
                          </a>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </Col>
          </Row>

          {/* Map or Additional Info */}
          <Row className="mt-5">
            <Col className="text-center">
              <div className="bg-white border rounded-4 p-5 shadow-sm">
                <h3 className="fw-bold mb-3">Service Areas</h3>
                <p className="lead text-muted mb-4">
                  We proudly serve the greater metropolitan area and surrounding
                  communities with professional HVAC services for both
                  residential and commercial properties.
                </p>
                <div className="row g-3 justify-content-center">
                  <div className="col-md-3">
                    <div className="d-flex align-items-center justify-content-center">
                      <FaMapMarkerAlt className="text-primary me-2" />
                      <span>Downtown</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="d-flex align-items-center justify-content-center">
                      <FaMapMarkerAlt className="text-primary me-2" />
                      <span>Suburbs</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="d-flex align-items-center justify-content-center">
                      <FaMapMarkerAlt className="text-primary me-2" />
                      <span>Industrial Zone</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="d-flex align-items-center justify-content-center">
                      <FaMapMarkerAlt className="text-primary me-2" />
                      <span>Rural Areas</span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;
